import React from 'react';

import PropTypes from 'prop-types';

import ERROR_FILE_ICON from '@/assets/icons/si-glyph-document-error.svg';

import './Profile.css';

function Profile({label, onClick, id, profileNotFound}) {
  return (
    <div
      className="parentProfile"
      onClick={onClick}
      id={id}
    >
      <div className="row profileIcon center">
        {!profileNotFound && <span className="glyphicon glyphicon-file icon" />}
        {profileNotFound && (
          <img
            alt={ERROR_FILE_ICON}
            src={ERROR_FILE_ICON}
            height={50}
            width={50}
            className="glyphicon glyphicon-file icon"
          />
        )}
      </div>
      <div className="row profileLabel">
        <span>{label}</span>
      </div>
    </div>
  );
}

Profile.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  id: PropTypes.string,
  profileNotFound: PropTypes.bool,
};

Profile.defaultProps = {
  onClick: () => {},
  id: '',
  label: '',
  profileNotFound: false,
};

export default Profile;
